import {useFlags, useFlagsLoaded} from '@product-web/flags'
import {getIsOnboardedViaUKB4B, useUser} from '@product-web/shell/user'

export function useIsCompanyOnboardedViaB4B(): boolean {
    const featureFlags = useFlags()
    const featureFlagsLoaded = useFlagsLoaded()
    const user = useUser()
    const isOnboardedViaB4B = getIsOnboardedViaUKB4B(user)
    return featureFlagsLoaded && featureFlags.b4BNav && isOnboardedViaB4B
}
